import { render, staticRenderFns } from "./FacebookLogo.vue?vue&type=template&id=5530c61c&scoped=true&"
import script from "./FacebookLogo.vue?vue&type=script&lang=js&"
export * from "./FacebookLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5530c61c",
  null
  
)

export default component.exports